import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatMinorUnits } from '../reportFormatters';

function CommercialValue({ basis = 'without_vat', commercialValue, directAllocationValue, netSales }) {
  const combined = commercialValue || netSales;
  return (
    <div className="report-commercial-value">
      <span><FormattedMessage id="components.pages.reports.money.paidNet"/>: <strong>{formatMinorUnits(netSales, basis)}</strong></span>
      <span><FormattedMessage id="components.pages.reports.money.directAllocation"/>: <strong>{formatMinorUnits(directAllocationValue, basis)}</strong></span>
      <span className="report-commercial-value__total"><FormattedMessage id="components.pages.reports.money.commercial"/>: <strong>{formatMinorUnits(combined, basis)}</strong></span>
    </div>
  );
}

export { CommercialValue };
